import { cubicBezier } from 'framer-motion';

// Luxury easing curves
export const easeLuxury = cubicBezier(0.4, 0, 0.2, 1);
export const easeSlow = cubicBezier(0.2, 0, 0, 1);
export const easeOutSlow = cubicBezier(0, 0, 0.2, 1);

// Animation variants
export const fadeUpSlow = {
    hidden: {
        opacity: 0,
        y: 30,
        transition: { duration: 0 }
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            ease: easeSlow,
            delay: 0.2
        }
    }
};

export const fadeIn = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.6,
            ease: easeLuxury
        }
    }
};

export const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] }
};

export const scaleIn = {
    hidden: {
        opacity: 0,
        scale: 0.95
    },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.7,
            ease: easeLuxury
        }
    }
};

export const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.3
        }
    }
};

export const staggeredChildren = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: easeLuxury
        }
    }
};

// Hover animations
export const floatAnimation = {
    hover: {
        y: -8,
        boxShadow: "0 25px 50px rgba(0,0,0,0.12)",
        transition: { duration: 0.5, ease: easeLuxury }
    }
};

export const hoverScale = {
    hover: {
        scale: 1.05,
        transition: { duration: 0.4, ease: easeLuxury }
    }
};

export const hoverGlow = {
    hover: {
        boxShadow: "0 0 30px rgba(212, 180, 131, 0.3)",
        transition: { duration: 0.4, ease: easeLuxury }
    }
};

// Page transitions
export const pageTransition = {
    initial: { opacity: 0, y: 20 },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            ease: easeSlow
        }
    },
    exit: {
        opacity: 0,
        y: -20,
        transition: {
            duration: 0.6,
            ease: easeOutSlow
        }
    }
};

// Filter animations
export const filterExpand = {
    collapsed: {
        height: "60px",
        boxShadow: "0 2px 15px rgba(0,0,0,0.03)"
    },
    expanded: {
        height: "auto",
        boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
        transition: {
            duration: 0.5,
            ease: easeLuxury
        }
    }
};

// Loading skeleton shimmer
export const shimmerAnimation = {
    initial: { x: "-100%" },
    animate: {
        x: "100%",
        transition: {
            duration: 1.5,
            ease: "linear",
            repeat: Infinity
        }
    }
};

// Product card entrance
export const cardEntrance = (index) => ({
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.7,
            ease: easeLuxury,
            delay: index * 0.1
        }
    }
});

// Text reveal
export const textReveal = {
    hidden: { opacity: 0, y: "100%" },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 1,
            ease: easeSlow
        }
    }
};

// Parallax effect
export const parallaxEffect = {
    initial: { y: 0 },
    animate: (y) => ({
        y: y * 0.5,
        transition: {
            duration: 1,
            ease: easeLuxury
        }
    })
};

export const heroReveal = {
    initial: { opacity: 0, y: 40 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 1, ease: [0.16, 1, 0.3, 1] }
};

// Micro-interactions
export const tapAnimation = {
    tap: {
        scale: 0.98,
        transition: { duration: 0.1 }
    }
};

export const whileTap = {
    scale: 0.98,
    transition: { duration: 0.1 }
}

export const cardStagger = {
    animate: {
        transition: {
            staggerChildren: 0.1
        }
    }
};
export const cardFloat = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
};

